<p>
  machine-monitoring works!
</p>
